import { Directive, ElementRef, Renderer2 } from '@angular/core'

const SCROLL_AMOUNT = 4
const SCROLL_TIMEOUT = 33
const LEFT_BTN = 'button.left-btn'
const RIGHT_BTN = 'button.right-btn'
const DISPLAY_NONE = 'display-none'
const START_EVENTS = ['mousedown', 'touchstart', 'keydown']
const END_EVENTS = ['mouseup', 'mouseout', 'touchend', 'keyup']

@Directive({
  selector: '[scrollingTable]',
})
export class ScrollingTableDirective {
  private readonly el: HTMLElement
  ro: ResizeObserver
  mouseDownHandler
  constructor(
    private readonly ref: ElementRef,
    private readonly renderer: Renderer2,
  ) {
    this.el = ref.nativeElement
  }

  ngAfterViewInit() {
    this.addButtons()
    this.ro = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        this.setScrollable(entries)
      })
    })
    this.ro.observe(this.el)
  }

  ngOnDestroy() {
    if (this.mouseDownHandler) {
      clearInterval(this.mouseDownHandler)
    }
    this.ro.unobserve(this.el)
  }

  setScrollable(entries) {
    for (const entry of entries) {
      const target = entry.target.parentElement
      const noScroll =
        target.scrollWidth <= Math.ceil(target.getBoundingClientRect().width)
      if (!noScroll) {
        this.renderer.addClass(this.el, 'scrollable')
        this.setButtonAttributes()
        this.onScroll(this.el.parentElement)
      } else {
        this.renderer.removeClass(this.el, 'scrollable')
        this.renderer.addClass(this.el.querySelector(LEFT_BTN), DISPLAY_NONE)
        this.renderer.addClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
      }
    }
  }

  addButtons() {
    this.el
      .querySelector('thead')
      .insertAdjacentHTML(
        'beforeend',
        '<button aria-label="Scroll left" class="left-btn display-none">&LeftAngleBracket;</button>',
      )
    this.el
      .querySelector('thead')
      .insertAdjacentHTML(
        'beforeend',
        '<button aria-label="Scroll right" class="right-btn display-none">&RightAngleBracket;</button>',
      )
    const leftBtn: HTMLElement = this.el.querySelector(LEFT_BTN)
    const rightBtn: HTMLElement = this.el.querySelector(RIGHT_BTN)
    START_EVENTS.forEach((event) =>
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      leftBtn.addEventListener(event, this.onMouseDown(-1)),
    )
    END_EVENTS.forEach((event) =>
      leftBtn.addEventListener(event, this.onMouseUp()),
    )
    START_EVENTS.forEach((event) =>
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      rightBtn.addEventListener(event, this.onMouseDown(1)),
    )
    END_EVENTS.forEach((event) =>
      rightBtn.addEventListener(event, this.onMouseUp()),
    )
    this.el.parentElement.addEventListener('scroll', () => {
      this.onScroll(this.el.parentElement)
    })
    this.setButtonAttributes()
  }

  setButtonAttributes() {
    const firstCell: HTMLElement = this.el.querySelector('thead tr th')
    const leftBtn: HTMLElement = this.el.querySelector(LEFT_BTN)
    const rightBtn: HTMLElement = this.el.querySelector(RIGHT_BTN)
    leftBtn.setAttribute(
      'style',
      `height: ${firstCell.offsetHeight}px; left: ${firstCell.offsetWidth}px; top: 0;`,
    )
    rightBtn.setAttribute(
      'style',
      `height: ${firstCell.offsetHeight}px; right: 0; top: 0;`,
    )
  }

  onMouseDown(direction) {
    return (event) => {
      if (
        event.type === 'keydown' &&
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return
      }
      this.mouseDownHandler = setInterval(() => {
        this.el.parentElement.scrollLeft += SCROLL_AMOUNT * direction
      }, SCROLL_TIMEOUT)
    }
  }

  onMouseUp() {
    return () => {
      if (this.mouseDownHandler) {
        clearInterval(this.mouseDownHandler)
      }
    }
  }

  onScroll(parent) {
    const maxScrollDistance = parent?.scrollWidth - parent?.clientWidth
    const scrollPosition = Math.ceil(parent?.scrollLeft)
    if (scrollPosition === 0) {
      this.renderer.addClass(this.el.querySelector(LEFT_BTN), DISPLAY_NONE)
    } else if (
      this.el.querySelector(LEFT_BTN).classList.contains(DISPLAY_NONE)
    ) {
      this.renderer.removeClass(this.el.querySelector(LEFT_BTN), DISPLAY_NONE)
    }
    if (maxScrollDistance <= scrollPosition) {
      this.renderer.addClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
    } else if (
      this.el.querySelector(RIGHT_BTN).classList.contains(DISPLAY_NONE)
    ) {
      this.renderer.removeClass(this.el.querySelector(RIGHT_BTN), DISPLAY_NONE)
    }
  }
}
